//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, destroy } from '@/apis/activity'
import moment from 'moment';
export default {
    data() {
        return {
            config: {
                //運動類型
                status: [
                    {
                        id: 1, name: "啟用",

                    },
                    {
                        id: 2, name: "停用",
                    }
                ],
            },
            searchQuery: {
                status: '',
                name: '',
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '名稱', dataIndex: 'name', key: 'name', width: 330, },
            { title: '主辦方', dataIndex: 'author', key: 'author', width: 330, },
            { title: '預覽次數', dataIndex: 'viewTotal', key: 'viewTotal', width: 330, },
            { title: '收藏次數', dataIndex: 'favoriteTotal', key: 'favoriteTotal', width: 330, },
            { title: '期數', dataIndex: 'num', key: 'num', width: 330, },
            { title: '價格', key: 'amount', width: 150, scopedSlots: { customRender: 'amountSlot' }, },
            { title: '狀態', key: 'status', width: 100, scopedSlots: { customRender: 'statusSlot' }, },
            { title: '創建時間', dataIndex: 'createdTime', key: 'createdTime', width: 180, },
            { title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            // await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        async onPageConfig() {
            try {
                //加載運動類型
                const params = { typeCode: '', name: '', pageSize: 99, pageNumber: 1 };
                const res = await sportType_list(params);
                this.config.motions = res.data.records;
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.records = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        //獲取運動類型名稱
        getSportTypeName(code) {
            if (code && this.config.motions) {
                const data = this.config.motions.filter(item => item.typeCode == code);
                if (data && data.length > 0) {
                    return data[0].name
                }
            }
            return code;
        },

        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        //狀態更新
        async handleOnEditState(item, status) {
            //edit state
            try {
                const res = await venues_changeState(item.id, status);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //刪除行
        async handleOnDelete(item) {
            try {
                const res = await destroy(item.id);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                console.log('delete error', error);
            }
        },
        handleToDetails(id) {
            this.$router.push(`/gymnasium/${id}`);
        },
        handleToForm(id) {
            if (id > 0) {
                this.$router.push(`/activity/edit/${id}`);
            } else {
                this.$router.push('/activity/add');
            }

        }
    }
}
